import React from "react";

const Loader = () => {
  return (
	<main>
		<div className={`dash-cards-2 header`}>
			<h2 className="dash-title">LOADING</h2>
			<p>LOADING</p>
			
			<div className="overlay">
				<div className="overlay__inner">
					<div className="overlay__content">
						<span className="spinner"></span>
					</div>
				</div>
			</div>
		</div>
	</main>
  );
};

export default Loader;
